<template>
  <div>
    <Sidebar @sideBarWidth="getWidth" @setLoading="setLoading" />

    <div :style="{ 'margin-left': widthSidebar }">
      <v-app :style="{ 'background-color': env.NODE_ENV !== 'production' ? 'lightgoldenrodyellow' : '#fff' }">
        <div class="d-flex justify-content-end px-5">
          <span>{{ userObj.username }}<br /></span>
        </div>
        <div class="d-flex justify-content-end px-5">
          <span>Roles: {{ userObj.roles }}</span>
        </div>
        <v-container> <router-view></router-view> </v-container>
      </v-app>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/sidebar/Sidebar";
import { TokenService } from "@/services/storage.service";
export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      widthSidebar: null,
      isLoading: false,
      userObj: {},
      env: process.env,
    };
  },
  mounted() {
    this.getWidth();
    this.parseJwt();
  },
  methods: {
    getWidth(value) {
      this.widthSidebar = value || "250px";
    },
    setLoading(value) {
      this.isLoading = value;
    },
    parseJwt() {
      const token = TokenService.getToken();
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replaceAll('-', "+").replaceAll('_', "/");
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.codePointAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      const json = JSON.parse(jsonPayload);
      this.userObj = {
        username: json.username,
        roles: json.roles.join(", "),
      };
    },
  },
};
</script>

<style>
.v-application ul {
  padding-left: 0 !important;
}

.v-sidebar-menu .vsm--item {
  white-space: normal !important;
}
</style>
